module.exports = __webpack_public_path__ + "img/whale.acc5ba9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/honor_system/whale.png
// module id = RH/f
// module chunks = 15